<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Demon Witch</h1>
</div>
</div>
<h4 class="double" style="text-align: center;">
	Book Two - The Ravenscliff Series</h4>
<h3 style="text-align: center;">
<br/>
	Geoffrey Huntington</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap149101.vue?085b426d